<template>
  <!-- We are currently using static/dummy divs rather than the respective Block and NewBlock components for the sake of performance and simplicity... this might be stupid and the following divs could eventually be replaced with their official counterparts ¯\_(ツ)_/¯ -->

  <div
    :class="['flexRow', 'blockRow', color, size, orientation]"
    @mouseenter="showCount = true"
    @mouseleave="showCount = false"
  >
    <div class="rowLabel" v-if="label.length > 0">
      {{ showCount ? completed : label }}
    </div>
    <div v-for="n in numFit" :class="'block ' + (n == numFit ? 'last' : '')" />
    <!-- FIXME - Do this with CSS -->

    <!-- TODO - TEST ME HORIZONTALLY -->
    <div v-if="numExtra > 0" class="additionalBlocksLabel">+{{ numExtra }}</div>

    <!-- TODO - Mark end of quota in completed blocks somehow -->

    <div v-for="n in numRemaining" class="block new quota" />

    <div v-if="quota == 0 && completed == 0" class="block new quota quotaMet" />
  </div>
</template>

<script>
export default {
  name: "static-block-row",
  components: {},
  props: {
    color: {
      type: String,
      default: "blue",
    },
    quota: Number,
    completed: Number,
    size: {
      type: String,
      default: "",
    },
    orientation: {
      type: String,
      default: "horizontal",
    },
    label: {
      type: String,
      default: "",
    },
    maxNumBlocks: Number,
  },
  data() {
    return {
      showCount: false,
    };
  },
  computed: {
    numRemaining() {
      return Math.max(this.quota - this.completed, 0);
    },
    numFit() {
      return this.maxNumBlocks ? Math.min(this.completed, this.maxNumBlocks) : this.completed;
    },
    numExtra() {
      return this.maxNumBlocks ? Math.max(this.completed - this.maxNumBlocks, 0) : 0;
    },
    isQuotaMet() {
      return this.completed >= this.quota;
    },
  },
};
</script>

<style>
.flexRow.blockRow.small > .block {
  width: 0.875rem;
  height: 0.875rem;
  margin: 0.1875rem;
}

.flexRow.blockRow.vertical {
  flex-direction: column-reverse;
}

.vertical .additionalBlocksLabel {
  background: white;
  border: none;
  position: relative;
  left: -2px;
  font-size: 0.75rem;
  width: 100%;
  text-align: center;
}

.rowLabel {
  width: 1.25rem;
  height: 0.875rem;
  margin: 0.1875rem 0;
  font-size: 0.75rem;
}
</style>



// WEBPACK FOOTER //
// StaticBlockRow.vue?ffdc2f60